import { useEffect } from 'react'
import { useLocation } from 'react-router-dom'
import { getPublicCheckoutEventId } from './publicCheckoutRoute'

const APP_STORE_ID = '6462697936'
const CANONICAL_APP_OPEN_BASE = 'https://baila.social/event'

const buildAppleBannerContent = (pathname: string, search: string) => {
  const params = new URLSearchParams(search)
  const refBy = params.get('refBy')
  const checkoutEventId = getPublicCheckoutEventId(pathname)

  if (checkoutEventId) {
    const canonicalParams = new URLSearchParams({ eventId: checkoutEventId })
    if (refBy) {
      canonicalParams.set('refBy', refBy)
    }
    return `app-id=${APP_STORE_ID}, app-argument=${CANONICAL_APP_OPEN_BASE}?${canonicalParams.toString()}`
  }

  if (pathname === '/event' || pathname.startsWith('/event/')) {
    const eventId = params.get('eventId')
    if (eventId) {
      const canonicalParams = new URLSearchParams({ eventId })
      if (refBy) {
        canonicalParams.set('refBy', refBy)
      }
      return `app-id=${APP_STORE_ID}, app-argument=${CANONICAL_APP_OPEN_BASE}?${canonicalParams.toString()}`
    }

    return `app-id=${APP_STORE_ID}`
  }

  return null
}

export default function DeepLinkBannerMeta() {
  const location = useLocation()

  useEffect(() => {
    const content = buildAppleBannerContent(location.pathname, location.search)
    const selector = 'meta[name="apple-itunes-app"]'
    let meta = document.head.querySelector<HTMLMetaElement>(selector)

    if (!content) {
      if (meta) {
        meta.remove()
      }
      return
    }

    if (!meta) {
      meta = document.createElement('meta')
      meta.name = 'apple-itunes-app'
      document.head.appendChild(meta)
    }

    meta.content = content
  }, [location.pathname, location.search])

  return null
}
